import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { ProgressButtonWebElement } from './ProgressButtonWebElement';
export { ProgressButtonWebElement };

/**
 * Retrieve an instance of [ProgressButtonWebElement](../classes/ProgressButtonWebElement.html).
 * @example
 * ```javascript
 * import { findProgressButton } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findProgressButton(driver, By.id('my-oj-c-progress-button'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findProgressButton(
  driver: DriverLike,
  by: By
): Promise<ProgressButtonWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type ProgressButtonWebElement
  if (!(webEl instanceof ProgressButtonWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'ProgressButtonWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findProgressButton(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${ProgressButtonWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-progress-button', ProgressButtonWebElement);
